import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@progress/kendo-react-buttons';
import { Splitter } from "@progress/kendo-react-layout";
// import _ from 'lodash';

// import DropDownList from './forms/DropDownList';
import eventEmitter from './utils/eventEmitter';
import withStorage from './utils/withStorage';

import './Tabs.scss';

// const DATA = [
//   { name: 'štandardný', id: 0, icon: "columns", class: "view-standard" },
//   { name: 'zoznam a detail', id: 1, icon: "rows", class: "view-rows" },
//   { name: 'detail a zoznam', id: 2, icon: "layout-stacked", class: "view-rows" },
//   { name: 'vedľa seba', id: 3, class: "view-side-by-side" }
// ];

/**
 * Tabs wrapper component
 * @module
 * @param {array} children - Children
 * @param {string} [name] - Tab Name
 * @param {bool} localTabsType - Set standard type not from global storage 
 * @param {number} initialTabIndex - initial tab index
 */
const TabsComponent = (props) => {
  const [selectedTab, setTab] = useState(0);
  const [state, setState] = useState({
    type: { name: 'štandardný', id: 0, icon: 'columns', class: 'view-standard' },
    panes: [{
    }, {
      size: "50%",
      collapsible: true,
      min: "10%"
    }]
  });

  const ref = useRef();

  const handleChangeTab = useCallback(({ name, tab }) => {
    if (!props.name || name === props.name) {
      setTab(tab);
    }
    if (state.type.id === 3 && state.panes[1].collapsed) {
      setState((prevState) => ({
        ...prevState,
        panes: prevState.panes.map((x, index) => (index === 1 ? { ...x, collapsed: false } : x)),
      }));
    }
  }, [props.name, state.panes, state.type.id]);

  const handleChangeTabsType = (type) => {
    setState((prevState) => ({ ...prevState, type }));
  };

  // const handleDropDownChange = (type) => {
  //   setState((prevState) => ({ ...prevState, type }));
  //   if (!props.localTabsType) {
  //     props.storage.setTabsType(type);
  //   }
  // };

  const handleSplitterChange = (event) => {
    setState((prevState) => ({
      ...prevState,
      panes: event.newState,
    }));
  };

  useEffect(() => {
    setTab(props.initialTabIndex ?? 0);
  }, [props.name])

  useEffect(() => {
    eventEmitter.on('CHANGE_TAB', handleChangeTab);
    if (!props.localTabsType) {
      eventEmitter.on('CHANGE_TABS_TYPE', handleChangeTabsType);
    }

    return () => {
      eventEmitter.removeListener('CHANGE_TAB', handleChangeTab);
      eventEmitter.removeListener('CHANGE_TABS_TYPE', handleChangeTabsType);
    };
  }, [props.localTabsType, handleChangeTab]);

  useEffect(() => {
    const getTabsType = async () => {
      const type = await props.storage.getTabsType();
      if (type && type.id !== state.type.id) {
        setState((prevState) => ({ ...prevState, type }));
      }
    };

    if (!props.localTabsType) {
      getTabsType();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (state.type.id === 3) {
      if (ref.current) {
        const panes = [...ref.current.querySelectorAll('.card-body > div')];
        for (const pane of panes) {
          pane.classList.add('tab');
        }
      }
    }
  }, [state.type.id, state.panes]);

  // componentDidUpdate(prevProps, prevState) {
  //   if ((prevState.type.id !== this.state.type.id && this.state.type.id === 3) || !_.isEqual(prevState.panes, this.state.panes)) {
  //     if (this.ref.current) {
  //       const panes = [...this.ref.current.querySelectorAll(".card-body > div")];
  //       for (const pane of panes) {
  //         pane.classList.add("tab");
  //       }
  //     }
  //   }
  // }

  let tabs;
  if (props.children.length) {
    tabs = [...props.children.filter((x) => x)];
  } else {
    tabs = [props.children];
  }

  if (state.type.id === 2) {
    tabs = tabs.reverse();
  }

  return (
    <div className={`card ${state.type.id === 0 && tabs && tabs.length > 2 ? "card-tabs" : ""}`} ref={ref}>
      {/* {tabs.length === 2 && <span className="switch">
          <DropDownList
            name="type"
            data={DATA}
            textField="name"
            onChange={(name, value) => handleDropDownChange(value)}
            value={state.type}
            required={true}
          />
        </span>} */}
      {state.type.id === 0 && tabs && tabs.length > 2 &&
        <div className="card-header">
          {tabs.map((tab, index) => {
            return (
              <span key={index}>
                <Button
                  disabled={tab.props.disabled}
                  themeColor={index === selectedTab ? "primary" : 'base'}
                  onClick={() => setTab(index)}
                >
                  {tab.props.title}
                </Button>
              </span>);
          })}
        </div>
      }

      {state.type.id !== 3 &&
        <div
          className={`card-body ${state.type.class ? state.type.class : ''
            } ${state.type.id !== 0 ? ' compact' : ''
            }`}
        >
          {tabs.map((tab, index) => {
            if (tab.props.hideStandardInactive && index !== selectedTab && state.type.id === 0)
              return null;

            return (<div
              key={index}
              className={index === selectedTab || state.type.id !== 0 ? `tab visible mt-3` : 'tab hidden'}
            >
              {
                React.isValidElement(tab) ? React.cloneElement(tab, { isActiveTab: index === selectedTab || state.type.id !== 0 }) : tab
              }
            </div>)
          }
          )}
        </div>
      }{state.type.id === 3 &&
        <Splitter
          panes={state.panes}
          onChange={handleSplitterChange}
          className={`card-body view-side-by-side card-column compact`}
        >
          {tabs.map((tab, index) => {
            return React.isValidElement(tab) ? React.cloneElement(tab, { isActiveTab: index === selectedTab || state.type.id !== 0 }) : tab
          }
          )}
        </Splitter>
      }
    </div>
  );

}

const Tabs = withStorage(TabsComponent);

const TabsWrapper = (props) => {
  return (
    <div className="tabs">
      <Tabs
        children={props.children}
        name={props.name}
        localTabsType={props.localTabsType}
        initialTabIndex={props.initialTabIndex}
      />
    </div>
  );
};

TabsWrapper.propTypes = {
  children: PropTypes.array.isRequired,
  name: PropTypes.string,
  localTabsType: PropTypes.bool
}

export default TabsWrapper;